import { ASSETS, LINKS } from './shopData'
import { ShopButton, Reveal } from './ShopUI'

// Hero: headline "Make picks. Get the dub." with the hand-holding-phone art.
export default function ShopHero() {
  return (
    <section id="top" className="relative overflow-hidden bg-[#f6f1f1]">
      {/* Soft brand blobs behind the hero */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-[#b68bff]/25 blur-3xl" />
        <div className="absolute -right-16 top-40 h-80 w-80 rounded-full bg-[#EBFF59]/30 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-[#C6FF9C]/25 blur-3xl" />
      </div>

      {/* No bottom padding on the section — the hand/phone art bleeds to the
          hero's bottom edge like the Shopify original; the text column carries
          its own bottom spacing instead. */}
      <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-5 pt-14 sm:px-8 md:grid-cols-2 md:gap-6 md:pt-20">
        <Reveal className="pb-10 text-center md:pb-20 md:text-left">
          {/* Type set inline: the design system's unlayered h1 rule (size,
              line-height, tracking) beats Tailwind's layered utilities. */}
          <h1
            className="font-[var(--font-heading)] font-extrabold text-[#292237]"
            style={{ fontSize: 'clamp(3.25rem, 7.5vw, 5.75rem)', lineHeight: 0.98, letterSpacing: '-0.02em' }}
          >
            Make picks.
            <br />
            <span className="text-[#460069]">Get the dub.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-xl text-[#66626E] md:mx-0">
            Predict winners, compete with friends, and get cool merch.
          </p>
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row md:items-start">
            <ShopButton variant="primary" href={LINKS.register}>
              Join for free
            </ShopButton>
            {/* Points at the player-card product, not the storefront — this is
                the only merch link on the site that skips /merch. Every other
                one (nav, footer, CTA) still lands on the full store. */}
            <ShopButton variant="secondary" href={LINKS.product('dub-player-cards')}>
              Get cards
            </ShopButton>
          </div>
        </Reveal>

        <Reveal delay={120} className="relative flex justify-center self-end md:justify-end">
          <img
            src={ASSETS.heroPhone}
            alt="Hand holding a phone showing the dub app"
            className="block w-[78%] max-w-sm drop-shadow-2xl md:w-full md:max-w-md"
            loading="eager"
          />
        </Reveal>
      </div>
    </section>
  )
}
